/**
 * Replacement for the default outline when a control uses outline-none.
 * Matches NowCard / CalendarVisibility keyboard focus treatment.
 */
export const FOCUS_RING =
  'outline-none focus-visible:ring-2 focus-visible:ring-ring';
